import {
	PreferencesOut,
	useApiGetPreferences,
	useApiUpdatePreferences,
} from '@repo/api-codegen';
import { useQueryClient } from '@tanstack/react-query';

export function useUserPreferences() {
	const queryClient = useQueryClient();

	const { data: preferences } = useApiGetPreferences({});

	const { mutateAsync: updatePreferencesMutation } = useApiUpdatePreferences({
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['auth', 'preferences'] });
		},
	});

	return {
		preferences: preferences?.preferences || {},
		teamOrder: preferences?.preferences?.team_order || [],
		pinnedAiChatIds: preferences?.preferences?.pinned_ai_chats || [],
		updatePreferences: updatePreferencesMutation,
		updateTeamOrder: async (teamOrder: string[]) => {
			await updatePreferencesMutation({
				body: { preferences: { team_order: teamOrder } },
			});
			return teamOrder;
		},
		updatePinnedChatsOptimistic: async (pinnedChatIds: string[]) => {
			const previousPreferences = queryClient.getQueryData([
				'auth',
				'preferences',
			]);

			// Optimistically set pinned chats
			queryClient.setQueryData(
				['auth', 'preferences'],
				(old: PreferencesOut) => ({
					...old,
					preferences: {
						...old?.preferences,
						pinned_ai_chats: pinnedChatIds,
					},
				})
			);

			try {
				await updatePreferencesMutation({
					body: { preferences: { pinned_ai_chats: pinnedChatIds } },
				});
				return pinnedChatIds;
			} catch (error) {
				queryClient.setQueryData(['auth', 'preferences'], previousPreferences);
				throw error;
			}
		},
	};
}
